import { useMemo } from 'react';
import { useMutation } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { backend } from '../axios/backend';
import ProductForm from '../components/ProductForm';
import Breadcrumbs from '../components/ui/Breadcrumbs';
import { useAppContext } from '../context/AppContext';
import { useIdeas } from '../hooks/useIdeas';
import { parseErrorMessage } from '../utils/error-message';

const EditIdeaForPersonPage = () => {
  const { alertSuccess, alertError } = useAppContext();
  const navigate = useNavigate();
  const params = useParams();

  const ideasQuery = useIdeas(params.personId || '', { refetchOnMount: false, refetchOnWindowFocus: false });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const idea = useMemo(() => ideasQuery.data?.ideas.find((i) => i.id === params.ideaId), [ideasQuery.data]);

  const mutation = useMutation(
    async (values: {
      name: string;
      price?: number;
      comment?: string;
      url?: string;
      tags?: string[];
      imageUrl?: string;
    }) => {
      await backend.patch(`/person/${params.personId}/idea/${params.ideaId}`, values);
    },
    {
      onSuccess: () => {
        ideasQuery.refetch();
        alertSuccess('Idee bearbeitet.');
        navigate(`/ideas/${params.personId}`);
      },
      onError: (e) => {
        alertError(parseErrorMessage(e));
      },
    },
  );

  return (
    <div style={{ margin: '2rem' }} className="space-y-4">
      <Breadcrumbs
        crumbs={[
          { text: 'Ideen', route: '/ideas' },
          { text: ideasQuery.data?.person.name || 'Person', route: '/ideas/' + params.personId },
          { text: 'Idee bearbeiten', route: `/ideas/${params.personId}/add` },
        ]}
      />
      <h1 className="text-white text-xl">
        <b>Idee bearbeiten</b>
      </h1>
      {idea && (
        <ProductForm
          onSubmit={mutation.mutate}
          isLoading={mutation.isLoading}
          submitText="Idee bearbeiten"
          type="idea"
          product={idea}
        />
      )}
    </div>
  );
};

export default EditIdeaForPersonPage;
